export default __webpack_public_path__ + "static/media/photo--sm--wheel-1.ea0388a7.jpg";